import * as React from "react";
import Marquee from "react-marquee-slider";
import styles from "./styles.module.scss";
import { MemoMessageModal as MessageModal } from "../../modals/MessageModal";
import Dialog from "../../Dialog";
import { useQuery } from "@apollo/client";
import {
  EventBySlugQuery,
  GetApprovedMessagesQuery,
  GetApprovedMessagesQueryVariables,
} from "@src/@types/api.d";
import { GetApprovedMessages } from "@src/graphql/queries";
import { getCookie } from "cookies-next";
import {
  ApprovedMessage,
  ApprovedMessages,
} from "@src/components/BirthdayTemplate1/MarqueeComp";

type Props = {
  eventId: number;
  slugData: EventBySlugQuery | undefined;
};

const MarqueeComp: React.FC<Props> = ({ slugData, eventId }) => {
  const [open, setOpen] = React.useState<boolean>(false);
  const [show, setShow] = React.useState<boolean>(false);
  const currentAccessToken = getCookie("tsl") as string;
  const [isMarqueePaused, setIsMarqueePaused] = React.useState(false);

  const pauseMarquee = () => setIsMarqueePaused(true);
  const resumeMarquee = () => setIsMarqueePaused(false);

  React.useEffect(() => {
    setShow(true);
  }, []);

  const { data: getApprovedMessagesData } = useQuery<
    GetApprovedMessagesQuery,
    GetApprovedMessagesQueryVariables
  >(GetApprovedMessages, {
    skip: !eventId,
    fetchPolicy: "network-only",
    nextFetchPolicy: "cache-first",
    variables: { eventId },
    pollInterval: 1000 * 60,
  });

  const messagesToDisplay =
    getApprovedMessagesData?.getApprovedMessages &&
    getApprovedMessagesData.getApprovedMessages.length > 0 &&
    getApprovedMessagesData.getApprovedMessages;

  // Helper function to ensure at least 6 entries
  const repeatEntries = (
    entries: ApprovedMessage[] | null
  ): ApprovedMessages => {
    console.log(entries?.length);
    if (!entries || entries.length === 0) return [];
    if (entries.length >= 6) return entries;

    const length = entries.length;
    let repeated: ApprovedMessages = [];

    if (length === 1) {
      // Repeat single entry 6 times
      repeated = Array(6).fill(entries[0]);
    } else if (length === 2) {
      // Repeat the pair thrice
      repeated = [...entries, ...entries, ...entries];
    } else if (length === 3) {
      // Repeat each entry 2 times
      repeated = [...entries, ...entries];
    } else if (length === 4) {
      // Repeat each entry 2 times (total 8)
      repeated = [...entries, ...entries];
    } else if (length === 5) {
      // Repeat each entry 2 times (total 10)
      repeated = [...entries, ...entries];
    }

    return repeated;
  };

  if (!messagesToDisplay || messagesToDisplay.length === 0) return null;

  // Prepare even and odd indexed messages
  const evenMessages =
    repeatEntries(messagesToDisplay.filter((_, i) => i % 2 === 0)) ?? [];
  const oddMessages =
    repeatEntries(messagesToDisplay.filter((_, i) => i % 2 !== 0)) ?? [];

  return !!messagesToDisplay && messagesToDisplay.length > 0 ? (
    <section className="py-2  bg-[#725A3F]">
      <div>
        <div
          className={styles["home__marquee"]}
          onMouseEnter={pauseMarquee}
          onMouseLeave={resumeMarquee}
          onClick={pauseMarquee}
        >
          {/* First Marquee Row */}
          <div style={{ height: "250px", maxWidth: "100vw", width: "100%" }}>
            <Marquee
              velocity={isMarqueePaused ? 0 : 40}
              direction="rtl"
              scatterRandomly={false}
              resetAfterTries={200}
              onInit={() => null}
              onFinish={() => null}
            >
              {evenMessages!.map((item, index) => (
                <div
                  key={`quotes-${index}`}
                  className={styles["home__special-note-box"]}
                >
                  <p
                    className={`${styles["home__special-note-text"]} font-ebGaramond`}
                  >
                    {item?.content ?? ""}
                  </p>
                </div>
              ))}
            </Marquee>
          </div>

          {/* Second Marquee Row */}
          {messagesToDisplay.length > 1 && (
            <div style={{ height: "250px", maxWidth: "100vw", width: "100%" }}>
              <Marquee
                velocity={isMarqueePaused ? 0 : 40}
                direction="rtl"
                scatterRandomly={false}
                resetAfterTries={200}
                onInit={() => null}
                onFinish={() => null}
              >
                {oddMessages!.map((item, index) => (
                  <div
                    key={`quotes-2-${index}`}
                    className={styles["home__special-note-box"]}
                  >
                    <p
                      className={`${styles["home__special-note-text"]} font-ebGaramond`}
                    >
                      {item?.content ?? ""}
                    </p>
                  </div>
                ))}
              </Marquee>
            </div>
          )}

          {/* Special Note Button */}
          {show && !!currentAccessToken && (
            <div>
              <Dialog
                trigger={
                  <div
                    className={`${styles["home__special-note__btn"]} font-neue`}
                  >
                    Drop a special note
                  </div>
                }
                open={open}
                onOpenChange={setOpen}
              >
                <MessageModal
                  name={slugData?.eventBySlug?.name ?? ""}
                  eventId={eventId}
                  setOpen={setOpen}
                />
              </Dialog>
            </div>
          )}
        </div>
      </div>
    </section>
  ) : null;
};

export default MarqueeComp;
